export const iconFontAwesomeEditingXmark = (
	<i className="fa-solid fa-xmark"></i>
);
